import { useCssHandles } from '../../utils/functions';
import { useForm } from './Form';

// import { SubmitContext } from './logic/formState'

export type FormSubmitProps = {
	label?: string;
	formState?: string;
	setFormState?: any;
	componentId?: string;
};

const CSS_HANDLES = ['formSubmitContainer', 'formSubmitButton', 'formErrorServer', 'formErrorUserInput'] as const;

export default function FormSubmit({ label, componentId }: FormSubmitProps) {
	const { setFormState }: any = useForm();
	const { handles }: any = useCssHandles('vtex-store-form-0-x', CSS_HANDLES);

	return (
		<div data-selection={componentId} className={handles.formSubmitContainer}>
			<div className={handles.formSubmitButton}>
				<button
					onClick={(e) => {
						e.preventDefault();
						setFormState('success');
					}}
					className="vtex-button bw1 ba fw5 v-mid relative pa0 lh-solid br2 min-h-regular t-action bg-action-primary b--action-primary c-on-action-primary hover-bg-action-primary hover-b--action-primary hover-c-on-action-primary pointer"
				>
					<div
						className="vtex-button__label flex items-center justify-center h-100 ph6 "
						style={{ paddingTop: '.25em', paddingBottom: '.32em' }}
					>
						{label || 'Submit'}
					</div>
				</button>
			</div>
			<div className={handles.formErrorUserInput}></div>
			<div className={handles.formErrorServer}></div>
		</div>
	);
}
